"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_02({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`.cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m11.45,19.63c-.6,0-1.08-.49-1.08-1.08v-7.1c0-.6.49-1.08,1.08-1.08h7.1c.29,0,.56.11.77.32.21.21.32.48.32.77v7.1c0,.6-.49,1.08-1.08,1.08h-7.1Zm-.12-.96h7.34v-7.34h-7.34v7.34Z"
      />
      <path
        className="cls-1"
        d="m19.46,30c-1.26,0-2.29-1.03-2.29-2.29,0-.97.61-1.83,1.53-2.16l.28-.1v-2.2h-7.95v2.2l.28.1c.91.32,1.53,1.19,1.53,2.16,0,1.26-1.03,2.29-2.29,2.29s-2.29-1.03-2.29-2.29c0-.97.61-1.83,1.53-2.16l.28-.1v-2.2h-1.93c-.76,0-1.39-.62-1.39-1.39v-1.93h-2.2l-.1.28c-.32.91-1.19,1.53-2.16,1.53C1.03,21.74,0,20.72,0,19.46s1.03-2.29,2.29-2.29c.97,0,1.83.61,2.16,1.53l.1.28h2.2v-7.95h-2.2l-.1.28c-.32.91-1.19,1.53-2.16,1.53C1.03,12.83,0,11.81,0,10.54s1.03-2.29,2.29-2.29c.97,0,1.83.61,2.16,1.53l.1.28h2.2v-1.93c0-.76.62-1.39,1.39-1.39h1.93v-2.2l-.28-.1c-.91-.32-1.53-1.19-1.53-2.16,0-1.26,1.03-2.29,2.29-2.29s2.29,1.03,2.29,2.29c0,.97-.61,1.83-1.53,2.16l-.28.1v2.2h7.95v-2.2l-.28-.1c-.91-.32-1.53-1.19-1.53-2.16,0-1.26,1.03-2.29,2.29-2.29s2.29,1.03,2.29,2.29c0,.97-.61,1.83-1.53,2.16l-.28.1v2.2h1.93c.76,0,1.39.62,1.39,1.39v1.93h2.2l.1-.28c.32-.91,1.19-1.53,2.16-1.53,1.26,0,2.29,1.03,2.29,2.29s-1.03,2.29-2.29,2.29c-.97,0-1.83-.61-2.16-1.53l-.1-.28h-2.2v7.95h2.2l.1-.28c.32-.91,1.19-1.53,2.16-1.53,1.26,0,2.29,1.03,2.29,2.29s-1.03,2.29-2.29,2.29c-.97,0-1.83-.61-2.16-1.53l-.1-.28h-2.2v1.93c0,.76-.62,1.39-1.39,1.39h-1.93v2.2l.28.1c.91.32,1.53,1.19,1.53,2.16,0,1.26-1.03,2.29-2.29,2.29Zm0-3.61c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Zm-8.91,0c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Zm-2.83-4.1h14.42l.11-.25.04-.08V7.71H7.71v14.57Zm20-4.16c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Zm-25.42,0c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Zm25.42-8.91c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Zm-25.42,0c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33ZM19.46.96c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Zm-8.91,0c-.73,0-1.33.59-1.33,1.33s.59,1.33,1.33,1.33,1.33-.59,1.33-1.33-.59-1.33-1.33-1.33Z"
      />
    </svg>
  );
}
